import { render, staticRenderFns } from "./TopMoreOptions.vue?vue&type=template&id=1a9ae8a8&scoped=true&"
import script from "./TopMoreOptions.vue?vue&type=script&lang=js&"
export * from "./TopMoreOptions.vue?vue&type=script&lang=js&"
import style0 from "./TopMoreOptions.vue?vue&type=style&index=0&id=1a9ae8a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9ae8a8",
  null
  
)

export default component.exports